import { render, staticRenderFns } from "./Pkg.vue?vue&type=template&id=1f4beec6&scoped=true&"
import script from "./Pkg.vue?vue&type=script&lang=js&"
export * from "./Pkg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f4beec6",
  null
  
)

export default component.exports